import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TListedPlaylist } from '../../types/responses/video';

type TState = {
  loaded: boolean;
  pending: boolean;
  error: boolean;
  data: TListedPlaylist[];
};

const initialState: TState = {
  loaded: false,
  pending: false,
  error: false,
  data: [],
};

const listSlice = createSlice({
  name: 'playlist/all',
  initialState: initialState as TState,
  reducers: {
    startLoading: (state) => {
      state.loaded = false;
      state.pending = true;
      state.error = false;
    },
    finishLoading: (state, action: PayloadAction<TListedPlaylist[]>) => {
      state.loaded = true;
      state.pending = false;
      state.error = false;
      state.data = action.payload;
    },
    errorLoading: (state) => {
      state.loaded = false;
      state.pending = false;
      state.error = true;
    },
    resetState: (state) => {
      state.loaded = false;
      state.pending = false;
      state.error = false;
      state.data = [];
    },
  },
});

export const playListAllActions = listSlice.actions;
export const playListAllReducer = listSlice.reducer;
